<template>
  <layout>
    <page-header :header="$t('settings.title')" :header-small="section.name" />
    <form ref="form" class="content settings-columns" @submit.prevent="submit">
      <div class="settings-groups-wrapper">
        <div class="settings-column">
          <b-card>
            <fields />
          </b-card>
          <b-card class="test-email">
            <div class="test-email-form form-group row">

              <label class="test-email-label col-sm-4 col-form-label text-sm-right">{{ $t('smtp.new_layout_send_test_email') }}</label>
              <div class="test-email-input-group col-sm-8">
                <b-form-input
                  v-model="testEmail"
                  type="email"
                  :placeholder="$t('smtp.new_layout_enter_email_placeholder')"
                  class="test-email-input"
                  :disabled="testEmailSending"
                />
                <b-button
                  type="button"
                  variant="secondary"
                  class="test-email-btn"
                  :disabled="!testEmail || testEmailSending"
                  @click="sendTestEmail"
                >
                  {{ $t('general.new_layout_send') }}
                </b-button>
              </div>
              <div v-if="testEmailError" class="test-email-error text-danger mt-2">
                {{ testEmailError }}
              </div>
            </div>
          </b-card>
        </div>
        <div class="settings-column">
          <b-card>
            <div v-html="$t('smtp.new_layout_guide_text')"></div>
          </b-card>
        </div>
      </div>
      <b-button type="submit" variant="primary">
        {{ $t('general.save') }}
      </b-button>
    </form>
  </layout>
</template>

<script>
import find from 'lodash-es/find'
import { FormMixin } from 'stylemix-base'
import { mapState } from 'vuex'

export default {
  name: 'SettingsFormBookings',

  mixins: [FormMixin],

  data: () => ({
    model: {},
    groups: {},
    testEmail: '',
    testEmailSending: false,
    testEmailError: null,
  }),

  computed: {
    ...mapState('settings', {
      sections: (state) => state.sections,
    }),

    section() {
      const current = find(this.sections, { key: this.$route.params.section })
      return current || {}
    },
  },

  mounted() {
    this.loadForm()
  },

  methods: {
    loadForm() {
      this.$uiBlocker(
        this.$http
          .get(`admin-settings/sections/${this.$route.params.section}`)
          .then(({ data }) => {
            this.model = data.data.length !== undefined ? {} : data.data
            this.groups = data.groups
            this.setFields(data.fields)
          }),
        this.$refs.form
      )
    },

    submit() {
      this.$uiBlocker(
        this.$http
          .post(
            this.section?.options?.submit_url ||
              `admin-settings/sections/${this.$route.params.section}`,
            this.formData()
          )
          .then((response) => {
            this.$toast.success(response.data.message)
          }),
        this.$refs.form
      )
    },

    formData() {
      let formData = new FormData()
      this.fields.all().forEach((field) => {
        field.appendFormData(formData, this.model)
      })
      return formData
    },

    sendTestEmail() {
      this.testEmailError = null
      this.testEmailSending = true

      const promise = this.$http
        .post('admin-settings/test-email', { email: this.testEmail })
        .then((response) => {
          this.$toast.success(response.data.message)
        })
        .catch((err) => {
          const data = err.response?.data
          const message = data?.message || this.$t('smtp.test_email_error')
          const errorDetail = data?.error
          this.testEmailError = errorDetail ? `${message}: ${errorDetail}` : message
          this.$toast.error(message)
        })
        .finally(() => {
          this.testEmailSending = false
        })

      this.$uiBlocker(promise, this.$refs.form)
    },
  },
}
</script>

<style>
.settings-groups-wrapper {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.settings-column code {
  padding: 0;
}

@media (min-width: 767px) {
  .settings-groups-wrapper {
    flex-direction: row;
    align-items: flex-start;
    gap: 1rem;
  }

  .settings-column {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-width: 0;
  }
}

.test-email-form {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

@media (min-width: 480px) {
  .test-email-form {
    flex-direction: row;
    align-items: center;
  }

  .test-email-label {
    flex-shrink: 0;
    margin-bottom: 0;
  }

  .test-email-input-group {
    flex: 1;
    display: flex;
    min-width: 0;
  }

  .test-email-input {
    flex: 1;
    border-radius: 0.25rem 0 0 0.25rem;
  }

  .test-email-btn {
    border-radius: 0 0.25rem 0.25rem 0;
    border-left: none;
  }
}

@media(max-width: 480px) {
  .test-email-btn {
    margin-top: 1rem;
    width: 100%;
  }
}

.test-email-label {
  font-weight: 500;
  color: #495057;
}

.test-email-error {
  font-size: 0.9rem;
}

</style>
